const MeetUs = () => {
  return (
    <div
      id="meetUs"
      className="sticky top-0 left-0 z-50 mb-0 w-full bg-darkPurple py-2 lg:py-3 px-[10px] h-[40px] sm:h-[52px] "
    >
      <div className="block-container flex flex-col sm:flex-row items-center sm:justify-center !h-full">
        {/* <div className="flex items-center justify-center meet-block first h-full">
          <span className="text-[10px] md:text-sm text-white">
            Meet us at{" "}
            <span className="font-bold">SBC Summit 2025 in Lisbon</span>
          </span>
          <span className="text-[10px] md:text-sm text-[#67DC7A] font-medium ml-1">
            September 16-18
          </span>
        </div> */}
        <div className="flex items-center justify-center meet-block second h-full">
          <span className="text-[10px] md:text-sm text-white">
            <span className="font-bold">
              RegTechFlow is Already Live!{" "}
              <span className="text-[10px] md:text-sm text-[#67DC7A]  ml-1">
                Book Your Demo Today
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default MeetUs;
